import PriceCalculator from "../_controllers/PriceCalculator";
import PriceConditionController from "../_controllers/FieldConditions/PriceConditionController";

export default class ProductFieldOption {
    name;
    label;
    min_price;
    type;
    type_price;
    description;
    position;
    display_conditions;
    price_conditions;

    constructor(name, label, min_price, type, type_price, description, position, display_conditions, price_conditions) {
        this.name = name || '';
        this.label = label || '';
        this.min_price = parseFloat(min_price) || 0;
        this.type = type || '';
        this.type_price = parseFloat(type_price) || 0;
        this.description = description || '';
        this.position = position || 0;
        this.display_conditions = display_conditions || [];
        this.price_conditions = price_conditions || [];
    }

    static fromPlain(plainObj) {
        return new ProductFieldOption(
            plainObj.name || false,
            plainObj.label || false,
            plainObj.min_price || false,
            plainObj.type || false,
            plainObj.type_price || false,
            plainObj.description || false,
            plainObj.position || false,
            plainObj.display_conditions || [],
            plainObj.price_conditions || []
        )
    }

    getPricePerType() {
        return Number(parseFloat(this.type_price)).toFixed(2)
    }

    getTypeLabel() {
        return this.type === 'flat' ? '' : this.type;
    }

    getPrice(sizes) {
        
        if (!sizes) {
            return this.min_price || 0;
        }

        let calculatePrice = this.type_price;
        
        //todo: calculate price by the selected fileds
        
        switch (this.type) {
            case ('sqm'):
                return PriceCalculator.setMirrorSize(sizes).calculateSquareMeter(calculatePrice, this.min_price)
            case ('linear'):
                return PriceCalculator.setMirrorSize(sizes).calculateLinearMeter(calculatePrice, this.min_price)
            case ('flat'):
                return PriceCalculator.setMirrorSize(sizes).calculateFlat(calculatePrice, this.min_price)

        }
        return 0;
    }

    static toPlain(object) {
        const plain = {};
        Object.keys(object).forEach((item, value) => {
            plain[item] = object[item];
        })
        return plain;
    }


}